import React, {Fragment, useEffect, useState} from "react";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import RegisterForm from "../../../form/components/forms/RegisterForm";
import LoginForm from "../../../form/components/forms/LoginForm";
import {useDispatch, useSelector} from "react-redux";
import {useForm} from "react-final-form";
import {setAuthTabNumber} from "../../../form/actions/AuthTabActions";
import GoogleSignInButton from "./GoogleSignInButton";
import {logout} from "../../actions/UserActions";
import PolicyPopup from "../../../form/components/sections/PolicyPopup";

function AuthTab({registerButton, loginButton, onForgotPassword}) {
    const dispatch = useDispatch();
    const {change} = useForm();
    const {ipIsoCode, authorized, user} = useSelector(state => state.user);
    const authOptions = useSelector(state => state.authOptions.data);
    const subscribe = true;
    const {signUpEnabled, socialAuthStatusGoogle} = useSelector(state => state.site);
    const [activeTab, setActiveTab] = useState(signUpEnabled ? 0 : 1);
    const [isPopupOpen, setPopupOpen] = useState(false);
    const [initialTab, setInitialTab] = useState(0);

    useEffect(() => {
        if (authorized === false) {
            setTimeout(() => {
                setupDefaultRegisterForm();
            }, 0);
            onSelect(0);
        }
    }, [authorized, ipIsoCode]);

    if (authorized === undefined) {
        return null;
    }

    const onSelect = index => {
        console.log(index);
        setActiveTab(index);
        if (index === 0) {
            change('login', undefined);
            setupDefaultRegisterForm();
            dispatch(setAuthTabNumber(0));
        } else {
            change('register', undefined);
            dispatch(setAuthTabNumber(1));
        }
    }

    const setupDefaultRegisterForm = () => {
        change('register.phone.code', ipIsoCode);
        change('register.subscribe', subscribe);
    }

    const clickLogout = e => {
        e.preventDefault();
        dispatch(logout()).then(response => {
            if (response.type.search('_SUCCESS') >= 0){
                setActiveTab(1);
            }
        });
    }

    const openPopup = (tabIndex) => {
        setInitialTab(tabIndex);
        setPopupOpen(true);
    }

    return <Fragment>
        {authorized ? (
            <div className="form-group">
                <div className="page-title_v3">Your account</div>
                <div className="form-label">Email</div>
                <input type="text" value={user.email} disabled={true} className="control-input auth-form-known-input"/>
                <div className="auth-form-logout">
                    <span className="auth-form-logout-text">Would you like to switch accounts?</span>
                    <a href="#" className="log-out auth-form-logout-link" onClick={clickLogout}>
                        <span>Change account</span>
                    </a>
                </div>
            </div>
        ) : (
            <Tabs className="account-tabs" onSelect={onSelect} selectedIndex={activeTab}>
                <TabList style={{display: signUpEnabled ? 'none' : 'none'}}>
                    {signUpEnabled && <Tab>New Customer</Tab>}
                    <Tab>Already have an account?</Tab>
                </TabList>
                <div className="tab-switch-links" style={{display: signUpEnabled ? 'block' : 'none'}}>
                    {activeTab === 0 ? (
                        <div>
                            <div className="page-title_v3 page-title_v3-form">Create your account</div>
                            <span style={{fontSize: '16px', color: '#56657B'}}>Already have an account?</span><span onClick={() => onSelect(1)} style={{cursor: 'pointer', color: '#1757C1', marginLeft: '3px', fontSize: '16px', fontWeight: '500'}}>Log in</span>
                        </div>
                    ) : (
                        <div>
                            <div className="page-title_v3 page-title_v3-form">Sign in</div>
                            <span style={{fontSize: '16px', color: '#56657B'}}>Don't have an account yet?</span><span onClick={() => onSelect(0)} style={{cursor: 'pointer', color: '#1757C1', marginLeft: '3px', fontSize: '16px', fontWeight: '500'}}>Create your account</span>
                        </div>
                    )}
                </div>
                {!signUpEnabled && (
                    <div className="tab-switch-links">
                        <div>
                            <div className="page-title_v3 page-title_v3-form">Sign in</div>
                            <span style={{fontSize: '16px', color: '#56657B'}}>Don't have an account yet?</span><span onClick={() => window.location.href = "/order/"} style={{cursor: 'pointer', color: '#1757C1', marginLeft: '3px', fontSize: '16px', fontWeight: '500'}}>Create your account</span>
                        </div>
                    </div>
                )}
                {signUpEnabled && (<TabPanel>
                    <RegisterForm countryOptions={authOptions.countries}/>
                    {registerButton}
                </TabPanel>)}
                <TabPanel>
                    <LoginForm onForgotPassword={onForgotPassword}/>
                    {loginButton}
                </TabPanel>
            </Tabs>
        )}
        {!authorized && socialAuthStatusGoogle && (
            <span className="or-line"><span className="or-line-text">or</span></span>
        )}
        {!authorized && (<GoogleSignInButton />)}
        {!authorized && activeTab === 0 && (
            <div className="form-text g-terms">
                <p>
                    By signing in or creating an account, you agree with our <span> </span>
                    <a onClick={() => openPopup(0)}>Terms & Conditions</a>, <span> </span>
                    <a onClick={() => openPopup(1)}>Money Back Guarantee</a>, <span> </span>
                    <a onClick={() => openPopup(2)}>Privacy Policy</a> and <span> </span>
                    <a onClick={() => openPopup(3)}>Cookie Policy</a>
                </p>
            </div>
        )}
        <PolicyPopup isOpen={isPopupOpen} onClose={() => setPopupOpen(false)} initialTab={initialTab} />
    </Fragment>
}

export default AuthTab;